const config = {
    APP_NAME: "HOTEL BOOKING ADMIN",
    // API_ROOT: "https://testb.roomster.com.ua/api/v1",
    API_ROOT: "https://backend.roomster.com.ua/api/v1",
    DEFAULT_LANG_CODE: "uz",
};

export default config;
